import React, { Component } from "react";
import styled from "styled-components";
import moment from "moment";
import { SecondaryButton, DefaultModuleHeader, ButtonSizeOptions, ImageLoader, ButtonIcon } from "@loanbossinc/component-library";
const StyledImageHeader = styled.div`
&& {
    height: 30px;
    width: 30px;
    margin: 0;
    margin-bottom: 0.4em;
    display: inline-block;
    vertical-align: top !important;
}`;

const StyledImageLoader = styled(ImageLoader)`
   && {
       height: 30px;
       width: 30px;
       margin: 0;
   } 
`;

export class ActiveLoanHeader extends Component {

    getHeaderImages = (elements) => {
        const { authentication } = this.props;
        if (elements?.length > 0 && authentication) {
            return elements.reduce((accum, cur, index) => {
                if (!cur || !cur.lenderName) return accum;
                accum.push(
                    <StyledImageHeader key={index}>
                        <StyledImageLoader src={cur.logo} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} title={cur.lenderName} key={index} />
                    </StyledImageHeader>);
                return accum;
            }, []);
        }

        return [
            (<StyledImageHeader key={1}><StyledImageLoader src={""} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} title={"Lender Selection Needed"} key={1} /></StyledImageHeader>)
        ];
    }

    getHeadingTitle = (uniqueLenders) => {
      const { loans } = this.props;
      if (loans.length === 1 && uniqueLenders && uniqueLenders.length > 0) {
         const lenderNames = uniqueLenders.reduce((accum, cur) => {
            if (!cur || !cur.lenderName) return accum;
            accum.push(cur.lenderName);
            return accum;
         }, []).join(", ");
         return lenderNames.length > 60 ? lenderNames.slice(0, 60) + "..." : lenderNames;
      }
      else if (loans.length > 1) {
         return `${loans.length} Loan${loans.length === 1 ? "" : "s"}`;
      }
    }

    getSubTitle = () => {
      const { loans } = this.props;
      if (!loans.length) return null;
      if (loans.length === 1 && loans[0]) {
         const closingDate = loans[0].closingDate ? moment(loans[0].closingDate).format("YYYY") : "";
         return closingDate;
      }
      return "";
    }

    getButton = () => {
        const { buttonTitle, buttonOnClick } = this.props;
        return (<SecondaryButton size={ButtonSizeOptions.smFluid} label={buttonTitle} onClick={() => buttonOnClick()} />)
    }

    render() {
        const { distinctLenders } = this.props;
        return (
            <DefaultModuleHeader
                headerElement={this.getHeaderImages(distinctLenders)}
                headerTitle={this.getHeadingTitle(distinctLenders)}
                subTitle={this.getSubTitle()}
                button={this.getButton()}
            />
        )
    }
}
